<template>
	<input
		type="text"
		:min="min"
		:max="max"
		:value="display"
		@input="onInput"
		@change="onChange">
</template>

<script>
import {
	formatNumberPlain,
} from '@/lib/helper';

export default {
	name: 'priceDisplay',
	props: {
		value: {},
		min: {},
		max: {},
		format: {
			type: String,
			default: 'int', // int, float
		},
	},
	data() {
		return {};
	},
	methods: {
		parsePrice(price) {
			const text = `${price}`;
			const regex = this.isFloat ? /[^0-9.,-]/g : /[^0-9-]/g;
			let parsedPrice = text.replace(regex, '').trim();
			// change comma to dot
			parsedPrice = this.isFloat ? text.replace(/[^0-9.-]/g, '.').trim() : parsedPrice;

			const parsedPriceLength = parsedPrice.length;
			if (parsedPriceLength > 1 && parsedPrice.charAt(0) === '0') {
				parsedPrice = parsedPrice.substring(1, parsedPriceLength);
			}
			if (parsedPrice !== '') {
				if (this.isFloat) {
					const dotVal = (parsedPrice.match(/\./g) || []).length;
					console.log(dotVal);
					if (dotVal > 1) {
						parsedPrice = parseFloat(parsedPrice);
					}
				} else {
					parsedPrice = parseInt(parsedPrice);
				}
			}
			return parsedPrice;
		},
		onInput(event) {
			const value = event.target.value;
			const parsed = this.parsePrice(value);
			this.$emit('input', parsed);
			this.$forceUpdate();
		},
		onChange() {
			// const value = event.target.value;
			// const formatted = formatMoney(value);
			// this.$emit('input', formatted);
			// const intValue = (this.isFloat) ? parseFloat(value) : parseInt(value);
			// if (value === '') {
			// 	const min = this.min || 0;
			// 	this.$emit('input', min);
			// }
			// if (this.min && intValue < this.min) {
			// 	this.$emit('input', this.min);
			// } else if (this.max && intValue > this.max) {
			// 	this.$emit('input', this.max);
			// } else {
			// 	this.$emit('input', this.value);
			// }
		},
	},
	computed: {
		isFloat() {
			return this.format === 'float';
		},
		display() {
			if (this.isFloat) {
				return this.value;
			}
			return formatNumberPlain(this.value);
		},
	},
};
</script>
